import {useEffect} from 'react';

export const lifecycle = {
  componentDidMount: async (state: any, props: any) => {
    const {setLoading} = state;
    const {actions, users} = props;

    const _useEffect = async () => {
      try {
        if (users.pages.active.length === 0 || window.isInitial) {
          setLoading(true);

          await actions.users.getPagination(
            users.current,
            users.searchWords,
            users.sortState
          );

          setLoading(false);

          window.isInitial = false;
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };

    useEffect(() => {
      _useEffect();
    }, []);
  },
};
